/* eslint-disable react/no-unescaped-entities */
import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import withStyles from '@mui/styles/withStyles';
// import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import MuiDialogContent from '@mui/material/DialogContent';
// import MuiDialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Logo from '../../../../assets/Images/logo.png';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CloseIcon from '@mui/icons-material/Close';
import MuiDialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { Link } from "react-router-dom";

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

// const DialogActions = withStyles((theme) => ({
//     root: {
//         margin: 0,
//         padding: theme.spacing(1),
//     },
// }))(MuiDialogActions);


const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        minWidth: 550,
        maxWidth: 500
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                    size="large">
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DisplayAdmissionApplications = (props) => {
    const { handleClose = fn => fn, open = false, data = {}, documentData = [], onDownload = fn => fn } = props;
    const alevelData = data.alevelAcademicsSubjects || [];
    const interData = data.graduationAcademicsSubjectsInter || [];
    const bachData = data.graduationAcademicsSubjectsBachelors || [];
    const otherQualiications = data.otherQualifications || [];
    const activitiesData = data.coCurricularActivities || [];
    const workExperience = data.workExperience || [];
    const uclRelationData = data.relativesStatus || [];
    const aLevelSubjectData = data.alevelTakenSubjects || [];
    return (
        <div>
            <Dialog fullScreen onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>

                </DialogTitle>
                <DialogContent>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: '-80px'
                    }}>
                        <img alt="" src={Logo} width={100} />
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                marginLeft: 20
                            }}
                        >
                            <span style={{
                                fontSize: 40,
                                fontWeight: 'bolder',
                                fontFamily: 'sans-serif',
                                color: '#2f57a5',
                                letterSpacing: 1,
                            }}>Universal College Lahore</span>
                            <span style={{
                                fontSize: 20,
                                textAlign: 'center',
                                marginLeft: '-40px',
                                fontWeight: 600,
                                color: '#2f57a5',
                            }}>(a project of UCL pvt Ltd)</span>
                        </div>
                    </div>
                    <div style={{
                        display: 'flex',
                        marginLeft: '38%',
                        justifyContent: 'space-between'
                    }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <span style={{
                                padding: 6,
                                marginBottom: 10,
                                textAlign: 'center',
                                fontSize: 'larger',
                                backgroundColor: '#2f57a5',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                            }}>Application for Admission</span>
                            <span style={{
                                padding: 6,
                                marginBottom: 10,
                                fontSize: 'larger',
                                textAlign: 'center',
                                backgroundColor: '#2f57a5',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                            }}>{Number(data.degreeId) === 32 ? 'A Level Programme' : 'Undergraduate Programme'}</span>
                            <span style={{
                                padding: 6,
                                marginBottom: 10,
                                textAlign: 'center',
                                fontSize: 'larger',
                                backgroundColor: '#2f57a5',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                            }}>Application ID: {data.id}</span>
                        </div>

                        <div style={{
                            height: 140,
                            width: 130,
                            border: '1px solid',
                            marginLeft: 50,
                            textAlign: 'center',
                            marginTop: '-25px',
                            backgroundImage: `url(${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C01AdmissionsProspectApplicationImageView?fileName=${data.imageName})`,
                            backgroundSize: 'cover',
                            backgroundpPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                        }}>
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10,
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                Course Applied For
                            </span>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            marginTop: '1%',
                            marginBottom: '1%'
                        }}>
                            <span style={{
                                border: '1px solid',
                                paddingLeft: 15,
                                paddingBottom: 7,
                                paddingTop: 7,
                                paddingRight: 15,
                            }}>{data.degreeLabel}</span>
                            <span style={{
                                border: '1px solid',
                                paddingLeft: 15,
                                paddingBottom: 7,
                                paddingTop: 7,
                                paddingRight: 15,
                            }}>{data.academicSessionLabel}</span>
                        </div>
                        {data.degreeId === 8 &&
                            <Fragment>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                }}>
                                    <span style={{
                                        fontSize: 'larger'
                                    }}>
                                        Specify	the	degree	you	wish	to	transfer	to	after	completing	the	CHESS
                                    </span>
                                </div>
                                <div style={{
                                    marginLeft: '3%',
                                    marginTop: '1%',
                                    marginBottom: '1%'
                                }}>
                                    <span style={{
                                        border: '1px solid',
                                        paddingLeft: 15,
                                        paddingBottom: 7,
                                        paddingTop: 7,
                                        paddingRight: 15,
                                    }}>{data.chessDegreeTransferLabel}</span>
                                </div>
                            </Fragment>
                        }
                        {Number(data.degreeId) === 32 &&
                            <Fragment>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                    <div style={{
                                        backgroundColor: 'rgb(47, 87, 165)',
                                        color: 'white',
                                        '-webkit-print-color-adjust': 'exact',
                                        'color-adjust': 'exact',
                                        padding: 6,
                                        marginTop: 10,
                                        marginBottom: 10,
                                    }}>
                                        <span style={{
                                            fontSize: 'larger'
                                        }}>
                                            Year for A Level Admission
                                        </span>
                                    </div>
                                    <div style={{
                                        marginLeft: '3%',
                                        marginTop: '1%',
                                        marginBottom: '1%'
                                    }}>
                                        <span style={{
                                            border: '1px solid',
                                            paddingLeft: 15,
                                            paddingBottom: 7,
                                            paddingTop: 7,
                                            paddingRight: 15,
                                        }}>{`${data.alevelAdmissionYear} Year`}</span>
                                    </div>
                                </div>
                            </Fragment>
                        }
                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10,
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                Category
                            </span>
                        </div>
                        <div style={{
                            marginLeft: '3%',
                            marginTop: '1%',
                            marginBottom: '1%'
                        }}>
                            <span style={{
                                border: '1px solid',
                                paddingLeft: 15,
                                paddingBottom: 7,
                                paddingTop: 7,
                                paddingRight: 15,
                            }}>{data.isTransferCandidate === 1 ? 'Transfer' : 'New'}</span>
                        </div>
                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                Personal Information
                            </span>
                        </div>


                        <div style={{
                            marginLeft: '3%',
                            marginTop: '1%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                Name
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '25%',
                                textAlign: 'Left'
                            }}>
                                {data.firstName}
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '25%',
                                textAlign: 'Left'
                            }}>
                                {data.middleName}
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '25%',
                                textAlign: 'Left'
                            }}>
                                {data.lastName}
                            </div>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                Date of Birth
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.dateOfBirth}
                            </div>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                marginLeft: 15,
                                textAlign: 'center'
                            }}>
                                Gender
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.genderLabel}
                            </div>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                Nationality
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.nationalityLabel}
                            </div>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                marginLeft: 15,
                                textAlign: 'center'
                            }}>
                                {data.studentIdentityLabel || 'CNIC'}
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.studentIdentity === 1 && data.cnicBform}
                                {data.studentIdentity === 2 && data.passportNumber}
                                {data.studentIdentity === 3 && data.nicopNumber}
                                {data.studentIdentity === 4 && data.cnicBform}
                            </div>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                Mobile Number
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.mobileNo}
                            </div>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                marginLeft: 15,
                                textAlign: 'center'
                            }}>
                                Email
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.email}
                            </div>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                Blood Group
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.bloodGroupLabel}
                            </div>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                marginLeft: 15,
                                textAlign: 'center'
                            }}>
                                Marital Status
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.maritalStatusLabel}
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                Permanent Address
                            </span>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                Address
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '80%',
                                textAlign: 'Left'
                            }}>
                                {data.permanentAddress}
                            </div>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                Country
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.permanentCountryLabel}
                            </div>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                marginLeft: 15,
                                textAlign: 'center'
                            }}>
                                Province
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.permanentProvinceLabel}
                            </div>
                        </div>


                        <div style={{
                            marginLeft: '3%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                City
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.permanentCityLabel}
                            </div>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                marginLeft: 15,
                                textAlign: 'center'
                            }}>
                                Postal Code
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.permanentPostalCode}
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                Present Address
                            </span>
                        </div>
                        {data.mailingAddressTypeId === 1 && (
                            <div style={{
                                marginLeft: '3%',
                                marginTop: '1%',
                                marginBottom: '1%'
                            }}>
                                <span style={{
                                    border: '1px solid',
                                    paddingLeft: 15,
                                    paddingBottom: 7,
                                    paddingTop: 7,
                                    paddingRight: 15,
                                }}>{data.mailingAddressTypeLabel}</span>
                            </div>
                        )}
                        {data.mailingAddressTypeId !== 1 && (<Fragment>
                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Address
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '80%',
                                    textAlign: 'Left'
                                }}>
                                    {data.mailingAddress}
                                </div>
                            </div>

                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Country
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.mailingCountryLabel}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Province
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.mailingProvinceLabel}
                                </div>
                            </div>


                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    City
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.mailingCityLabel}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Postal Code
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.mailingPostalCode}
                                </div>
                            </div>
                        </Fragment>)}
                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                Father's Information
                            </span>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                Title
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.fatherTitleLabel}
                            </div>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                marginLeft: 15,
                                textAlign: 'center'
                            }}>
                                Name
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.fatherName}
                            </div>
                        </div>

                        {data.fatherTitleId !== 6 && (<Fragment>

                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    {data.fatherIdentityTypeLabel || 'CNIC'}
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.fatherCnicPassport}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Mobile Number
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.fatherMobileNo}
                                </div>
                            </div>

                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Email
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.fatherEmail}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Occupation
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.fatherOccupationLabel}
                                </div>
                            </div>
                        </Fragment>)}

                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                Mother's Information
                            </span>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                Title
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.motherTitleLabel}
                            </div>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                marginLeft: 15,
                                textAlign: 'center'
                            }}>
                                Name
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.motherName}
                            </div>
                        </div>

                        {data.motherTitleId !== 6 && (<Fragment>

                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    {data.motherIdentityTypeLabel || 'CNIC'}
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.motherCnicPassport}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Mobile Number
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.motherMobileNo}
                                </div>
                            </div>

                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Email
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.motherEmail}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Occupation
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.motherOccupationLabel}
                                </div>
                            </div>

                        </Fragment>)}

                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                Guardian's Information
                            </span>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                Title
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.guardianTitleLabel}
                            </div>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                marginLeft: 15,
                                textAlign: 'center'
                            }}>
                                Name
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.guardianName}
                            </div>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                {data.guardianIdentityTypeLabel || 'CNIC'}
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.guardianCnicPassport}
                            </div>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                marginLeft: 15,
                                textAlign: 'center'
                            }}>
                                Mobile Number
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.guardianMobileNo}
                            </div>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                Email
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.guardianEmail}
                            </div>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                marginLeft: 15,
                                textAlign: 'center'
                            }}>
                                Occupation
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.guardianOccupationLabel}
                            </div>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                Relationship
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '80%',
                                textAlign: 'Left'
                            }}>
                                {data.guardianRelationWithStudentLabel}
                            </div>
                        </div>
                        {Number(data.degreeId) === 32 && (<Fragment>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10
                            }}>
                                <span style={{
                                    fontSize: 'larger'
                                }}>
                                    Financial
                                </span>
                            </div>
                            <span style={{ marginBottom: 10 }}>Name/address/profession of the person(s) responsible for the payment of tuition fee and other expenses.</span>

                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Name
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.financialName}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Profession
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.financialProfession}
                                </div>
                            </div>

                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Address
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '80%',
                                    textAlign: 'Left'
                                }}>
                                    {data.financialAddress}
                                </div>
                            </div>
                        </Fragment>)}


                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                Academics
                            </span>
                        </div>
                        {Number(data.degreeId) === 32 && (<Fragment>
                            <span style={{ marginBottom: 10 }}>Name and address of school last attended.</span>


                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Name
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.olevelSchoolName}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Address
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.olevelSchoolAddress}
                                </div>
                            </div>

                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10
                            }}>
                                <span style={{
                                    fontSize: 'larger'
                                }}>
                                    ‘O’ Level (or equivalent) examination results. In the ‘Exam Grade’ column write RA if results are awaited and TBT if exams are yet to be taken.
                                </span>
                            </div>

                            <table style={{
                                borderCollapse: 'collapse', marginLeft: '3%', marginTop: '1%',
                                marginBottom: '1%'
                            }}>
                                <tr>
                                    <th style={{
                                        border: '1px solid',
                                        padding: 10,
                                    }}>Subject</th>
                                    <th style={{
                                        border: '1px solid',
                                        padding: 10
                                    }}>Exam Title</th>
                                    <th style={{
                                        border: '1px solid',
                                        padding: 10
                                    }}>Board</th>
                                    <th style={{
                                        border: '1px solid',
                                        padding: 10
                                    }}>Session</th>
                                    <th style={{
                                        border: '1px solid',
                                        padding: 10
                                    }}>Grade</th>
                                </tr>
                                {
                                    alevelData.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td style={{
                                                    border: '1px solid',
                                                    padding: 10
                                                }}>{item.subject}</td>
                                                <td style={{
                                                    border: '1px solid',
                                                    padding: 10
                                                }}>{item.examTitle}</td>
                                                <td style={{
                                                    border: '1px solid',
                                                    padding: 10
                                                }}>{item.board}</td>
                                                <td style={{
                                                    border: '1px solid',
                                                    padding: 10
                                                }}>{item.session}</td>
                                                <td style={{
                                                    border: '1px solid',
                                                    padding: 10
                                                }}>{item.grade}</td>
                                            </tr>
                                        );
                                    })
                                }
                            </table>
                        </Fragment>)}

                        {Number(data.degreeId) !== 32 && (<Fragment>

                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 5
                            }}>
                                <span style={{
                                    fontSize: 'larger'
                                }}>
                                    Section 1: O-Level/FA/FSc/ICom/ICS/High School Diploma (Grade 12) or equivalent
                                </span>
                            </div>
                            <span style={{ marginBottom: 10 }}>State below the results of your subjects. These must include English Language and Maths (if taken). Where applicable the overall grade/marks must also be stated. Tick where appropriate.</span>

                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Name of Awarding Body
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.interAwardingBody}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Name of Institution
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.interInstitution}
                                </div>
                            </div>


                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Qualification
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.interQualification}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Year Awarded
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.interYearAwarded}
                                </div>
                            </div>


                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Result Awaited
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.interIsResultAwaiting === 1 ? 'Yes' : 'No'}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Overall Grade/Marks
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.interMarks}
                                </div>
                            </div>

                            <table style={{
                                borderCollapse: 'collapse', marginLeft: '3%', marginTop: '1%',
                                marginBottom: '1%'
                            }}>
                                <tr>
                                    <th style={{
                                        border: '1px solid',
                                        padding: 10,
                                        width: '50%'
                                    }}>Subject</th>
                                    <th style={{
                                        border: '1px solid',
                                        padding: 10
                                    }}>Grade/Marks</th>
                                </tr>
                                {interData.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td style={{
                                                border: '1px solid',
                                                padding: 10
                                            }}>{item.subject}</td>
                                            <td style={{
                                                border: '1px solid',
                                                padding: 10
                                            }}>{item.grade}</td>
                                        </tr>
                                    );
                                })}

                            </table>

                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 5
                            }}>
                                <span style={{
                                    fontSize: 'larger'
                                }}>
                                    Section 2: A-Level/BA/BSc/BCom/BCS/AP Exams after Grade 12 or equivalent
                                </span>
                            </div>
                            <span style={{ marginBottom: 10 }}>State below the results of your subjects.Where applicable the overall grade/marks must also be sated.</span>

                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Name of Awarding Body
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.bachelorsAwardingBody}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Name of Institution
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.bachelorsInstitution}
                                </div>
                            </div>


                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Qualification
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.bachelorsQualification}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Year Awarded
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.bachelorsYearAwarded}
                                </div>
                            </div>


                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Result Awaited
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.bachelorsIsResultAwaiting === 1 ? 'Yes' : 'No'}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Overall Grade/Marks
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.bachelorsGrade}
                                </div>
                            </div>

                            <table style={{
                                borderCollapse: 'collapse', marginLeft: '3%', marginTop: '1%',
                                marginBottom: '1%'
                            }}>
                                <tr>
                                    <th style={{
                                        border: '1px solid',
                                        padding: 10,
                                        width: '50%'
                                    }}>Subject</th>
                                    <th style={{
                                        border: '1px solid',
                                        padding: 10
                                    }}>Grade/Marks</th>
                                </tr>
                                {bachData.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td style={{
                                                border: '1px solid',
                                                padding: 10
                                            }}>{item.subject}</td>
                                            <td style={{
                                                border: '1px solid',
                                                padding: 10
                                            }}>{item.grade}</td>
                                        </tr>
                                    );
                                })}
                            </table>
                        </Fragment>)}

                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                Other Qualification
                            </span>
                        </div>

                        <table style={{
                            borderCollapse: 'collapse', marginLeft: '3%', marginTop: '1%',
                            marginBottom: '1%'
                        }}>
                            <tr>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10,
                                }}>Name of Awarding Body</th>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10
                                }}>Name of Institution</th>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10
                                }}>Qualification</th>
                            </tr>
                            {otherQualiications.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.awardingBody}</td>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.institution}</td>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.qualification}</td>
                                    </tr>
                                );
                            })}
                        </table>

                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                Extra and Co-Curricular Activities
                            </span>
                        </div>

                        <table style={{
                            borderCollapse: 'collapse', marginLeft: '3%', marginTop: '1%',
                            marginBottom: '1%'
                        }}>
                            <tr>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10,
                                    width: '20%'
                                }}>Name of Institution</th>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10,
                                    width: '20%'
                                }}>Tenure (Months)</th>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10,
                                    width: '20%'
                                }}>Activity</th>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10,
                                    width: '20%'
                                }}>Position</th>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10,
                                    width: '20%'
                                }}>Nature of Position Held</th>
                            </tr>
                            {activitiesData.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.institution}</td>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.tenureMonths}</td>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.activity}</td>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.position}</td>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.natureOfPositionHeld}</td>
                                    </tr>
                                );
                            })}
                        </table>
                        {Number(data.degreeId) !== 32 && (<Fragment>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10
                            }}>
                                <span style={{
                                    fontSize: 'larger'
                                }}>
                                    Work Experience
                                </span>
                            </div>

                            <table style={{
                                borderCollapse: 'collapse', marginLeft: '3%', marginTop: '1%',
                                marginBottom: '1%'
                            }}>
                                <tr>
                                    <th style={{
                                        border: '1px solid',
                                        padding: 10,
                                        width: '20%'
                                    }}>Organization</th>
                                    <th style={{
                                        border: '1px solid',
                                        padding: 10,
                                        width: '20%'
                                    }}>Tenure (Months)</th>
                                    <th style={{
                                        border: '1px solid',
                                        padding: 10,
                                        width: '20%'
                                    }}>Activity</th>
                                    <th style={{
                                        border: '1px solid',
                                        padding: 10,
                                        width: '20%'
                                    }}>Position</th>
                                    <th style={{
                                        border: '1px solid',
                                        padding: 10,
                                        width: '20%'
                                    }}>Nature of Position Held</th>
                                </tr>
                                {workExperience.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td style={{
                                                border: '1px solid',
                                                padding: 10
                                            }}>{item.organization}</td>
                                            <td style={{
                                                border: '1px solid',
                                                padding: 10
                                            }}>{item.tenureMonths}</td>
                                            <td style={{
                                                border: '1px solid',
                                                padding: 10
                                            }}>{item.activity}</td>
                                            <td style={{
                                                border: '1px solid',
                                                padding: 10
                                            }}>{item.position}</td>
                                            <td style={{
                                                border: '1px solid',
                                                padding: 10
                                            }}>{item.natureOfPositionHeld}</td>
                                        </tr>
                                    );
                                })}
                            </table>
                        </Fragment>)}
                        {Number(data.degreeId) === 32 && (<Fragment>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginRight: 20
                            }}>
                                <span style={{
                                    fontSize: 'larger'
                                }}>
                                    Subject Combinations
                                </span>
                            </div>

                            <div style={{
                                marginLeft: '3%',
                                marginTop: '1%',
                                marginBottom: '1%',
                                display: 'flex'
                            }}>
                                {aLevelSubjectData.map((item, index) => {
                                    return (
                                        <span key={index} style={{
                                            border: '1px solid',
                                            paddingLeft: 15,
                                            paddingBottom: 7,
                                            paddingTop: 7,
                                            paddingRight: 15,
                                            marginRight: 15
                                        }}>{item.subjectLabel}</span>
                                    );
                                })}
                            </div>
                        </Fragment>)}
                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                State the Name(s) and Present status of any relative related to UCL or BHS
                            </span>
                        </div>

                        <table style={{
                            borderCollapse: 'collapse', marginLeft: '3%', marginTop: '1%',
                            marginBottom: '1%'
                        }}>
                            <tr>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10,
                                }}>Institution</th>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10,
                                }}>Relationship</th>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10,
                                }}>Role</th>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10,
                                }}>Name</th>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10,
                                }}>Department</th>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10,
                                }}>Designation</th>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10,
                                }}>Programme</th>
                                <th style={{
                                    border: '1px solid',
                                    padding: 10,
                                }}>Graduation Year</th>
                            </tr>
                            {uclRelationData.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.institutionLabel}</td>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.relationship}</td>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.roleLabel}</td>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.name}</td>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.department}</td>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.designation}</td>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.programme}</td>
                                        <td style={{
                                            border: '1px solid',
                                            padding: 10
                                        }}>{item.graduationYear || ''}</td>
                                    </tr>
                                );
                            })
                            }
                        </table>

                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                Suffering from any medical condition/allergies
                            </span>
                        </div>


                        <div style={{
                            marginLeft: '3%',
                            marginTop: '1%',
                            marginBottom: '1%'
                        }}>
                            <span style={{
                                border: '1px solid',
                                paddingLeft: 15,
                                paddingBottom: 7,
                                paddingTop: 7,
                                paddingRight: 15,
                            }}>{data.isAnyMedicalCondition === 1 ? 'Yes' : 'No'}</span>
                        </div>
                        {data.isAnyMedicalCondition === 1 && (<Fragment>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10
                            }}>
                                <span style={{
                                    fontSize: 'larger'
                                }}>
                                    Emergency Contact Details
                                </span>
                            </div>

                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Medical Condition
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '80%',
                                    textAlign: 'Left'
                                }}>
                                    {data.medicalCondition}
                                </div>
                            </div>


                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Name
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.emergencyContactPersonName}
                                </div>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    Relationship
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.emergencyContactRelationshipLabel}
                                </div>
                            </div>

                            <div style={{
                                marginLeft: '3%',
                                display: 'flex'
                            }}>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    textAlign: 'center'
                                }}>
                                    Mobile Number
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '80%',
                                    textAlign: 'Left'
                                }}>
                                    {data.emergencyContactNumber}
                                </div>
                            </div>
                        </Fragment>)}
                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                How did you hear about UCL?
                            </span>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            display: 'flex'
                        }}>
                            <div style={{
                                backgroundColor: 'rgb(47, 87, 165)',
                                color: 'white',
                                '-webkit-print-color-adjust': 'exact',
                                'color-adjust': 'exact',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                width: '20%',
                                textAlign: 'center'
                            }}>
                                Source
                            </div>
                            <div style={{
                                border: '1px solid',
                                padding: 6,
                                marginTop: 10,
                                marginBottom: 10,
                                marginLeft: 15,
                                width: '28%',
                                textAlign: 'Left'
                            }}>
                                {data.uclSourceLabel}
                            </div>
                            {(data.uclSourceId === 1 || data.uclSourceId === 5) && (<Fragment>
                                <div style={{
                                    backgroundColor: 'rgb(47, 87, 165)',
                                    color: 'white',
                                    '-webkit-print-color-adjust': 'exact',
                                    'color-adjust': 'exact',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    width: '20%',
                                    marginLeft: 15,
                                    textAlign: 'center'
                                }}>
                                    {data.uclSourceId === 1 ? 'Newspaper/Magzine Name' : 'Other Source Name'}
                                </div>
                                <div style={{
                                    border: '1px solid',
                                    padding: 6,
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 15,
                                    width: '28%',
                                    textAlign: 'Left'
                                }}>
                                    {data.uclSourceId === 1 ? data.uclSourceName : data.uclOtherSource}
                                </div>
                            </Fragment>)}
                        </div>

                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                Clearly state your reasons for applying to UCL in support of your application.
                            </span>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            marginTop: 10,
                            marginBottom: 10
                        }}>
                            <TextField
                                id="reasons"
                                value={data.reasonsForApplying}
                                disabled
                                InputProps={{
                                    style: {
                                        color: "black"
                                    }
                                }}
                                multiline
                                rows={8}
                                variant="outlined"
                                fullWidth
                            />

                        </div>

                        <div style={{
                            backgroundColor: 'rgb(47, 87, 165)',
                            color: 'white',
                            '-webkit-print-color-adjust': 'exact',
                            'color-adjust': 'exact',
                            padding: 6,
                            marginTop: 10,
                            marginBottom: 10
                        }}>
                            <span style={{
                                fontSize: 'larger'
                            }}>
                                Undertaking
                            </span>
                        </div>

                        <div style={{
                            marginLeft: '3%'
                        }}>
                            <div style={{
                                paddingBottom: 10,
                                marginTop: 10,
                                fontSize: 16
                            }}><strong style={{ paddingRight: 10 }}>1.</strong>
                                I confirm that the information contained in this form is accurate
                                and complete to the best of my knowledge and that the submission
                                of inaccurate information can be considered sufficient cause for
                                terminating my enrollment at Universal College Lahore (UCL).
                            </div>
                            <div style={{
                                paddingBottom: 10,
                                fontSize: 16
                            }}><strong style={{ paddingRight: 10 }}>2.</strong>
                                I also understand that if I am required to submit any information/document(s)
                                in support of my application, it is my responsibility to obtain it and
                                submit it before the closing date.
                            </div>
                            <div style={{
                                paddingBottom: 10,
                                fontSize: 16
                            }}><strong style={{ paddingRight: 10 }}>3.</strong>
                                I shall adhere to all the deadline dates set by UCL and keep UCL informed in writing about any changes
                                that might occur in my contact addresses, e.g., postal/residential, phone numbers (landline as well as cell numbers),
                                email, etc. I understand that UCL shall not accept any responsibility for any consequences that may arise
                                from my failure to comply with the aforesaid;
                            </div>
                            <div style={{
                                paddingBottom: 10,
                                fontSize: 16
                            }}><strong style={{ paddingRight: 10 }}>4.</strong>
                                I also understand that, while UCL takes all reasonable steps to ensure the safety of the person,
                                property and health of every student, UCL cannot and does not undertake to be responsible for any harm,
                                loss and or damage that may arise for reason of conditions or circumstances beyond the control of UCL.
                            </div>
                            <div style={{
                                paddingBottom: 10,
                                fontSize: 16
                            }}><strong style={{ paddingRight: 10 }}>5.</strong>
                                Furthermore, I understand that it is the responsibility of the owners of the vehicles to ensure the safety
                                of their vehicles and note that UCL cannot and does not undertake to be responsible in case of theft and or damage.
                            </div>
                            <div style={{
                                paddingBottom: 10,
                                fontSize: 16
                            }}><strong style={{ paddingRight: 10 }}>6.</strong>
                                As parent/guardian of the student, I undertake to have received the Fee Structure and Rules
                                and confirm that these have been carefully read, understood and found affordable.
                            </div>
                            <div style={{
                                paddingBottom: 10,
                                fontSize: 16
                            }}><strong style={{ paddingRight: 10 }}>7.</strong>
                                Tuition fee once paid is not refundable irrespective of whether the student leaves
                                the course voluntarily or is asked to leave the course on academic, discipline or any other grounds.
                            </div>
                            <div style={{
                                paddingBottom: 10,
                                fontSize: 16
                            }}><strong style={{ paddingRight: 10 }}>8.</strong>
                                We (the applicant and the parents including the guardians as the case may be) give
                                our unconditional consent to the Universal College Lahore to use any of the pictures
                                of the student taken during college events/functions for marketing purposes
                                In regard to the above, this serves to confirm that Universal College Lahore
                                is indemnified by the parent/guardian and the student or any other party representing the student.
                            </div>
                        </div>

                        <div style={{
                            marginLeft: '3%',
                            marginTop: '1%',
                            marginBottom: '1%',
                            display: 'flex'
                        }}>
                            <div style={{
                                border: '1px solid',
                                paddingLeft: 15,
                                paddingBottom: 7,
                                paddingTop: 7,
                                paddingRight: 15,
                                width: '100%',
                                display: 'flex'
                            }}>
                                <CheckBoxIcon /> <div style={{
                                    marginLeft: 10,
                                    fontSize: 18
                                }}>I agree all terms and conditions.</div>
                            </div>
                        </div>

                    </div>
                    <div style={{
                        backgroundColor: 'rgb(47, 87, 165)',
                        color: 'white',
                        '-webkit-print-color-adjust': 'exact',
                        'color-adjust': 'exact',
                        padding: 6,
                        marginTop: 10,
                        marginBottom: 10
                    }}>
                        <span style={{
                            fontSize: 'larger'
                        }}>
                            Documents
                        </span>
                    </div>

                    <div style={{
                        marginBottom: '2%',
                        marginTop: '2%',
                        marginLeft: '3%',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        {documentData.map((item, index) => {
                            console.log(item);
                            return (
                                <Link key={index} onClick={() =>
                                    onDownload(item.fileName)
                                } style={{ marginBottom: 15 }}>

                                    {item.documentTypeLabel}
                                </Link>
                            );
                        })}
                    </div>
                </DialogContent>
                {/* <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        <CloseIcon />
                    </Button>
                </DialogActions> */}
            </Dialog>
        </div >
    );
};

DisplayAdmissionApplications.propTypes = {
    handleClose: PropTypes.func,
    onDownload: PropTypes.func,
    open: PropTypes.bool,
    data: PropTypes.object,
    documentData: PropTypes.array
};

export default DisplayAdmissionApplications;